module.exports = __webpack_public_path__ + "media/images/btn_edit_account-d4639be0ae320cb7c4017cc3593078b5.gif";